import querystring from 'querystring'

import config from 'config'

const getCtaUrl = ({ utms, role, omitUtmParams, metaQuery }) => {
  const params = {
    utm_source: utms.utm_source,
    utm_medium: utms.utm_medium,
    utm_campaign: utms.utm_campaign,
    utm_content: utms.utm_content,
    credclid: utms.credclid,
    credsessid: utms.credsessid,
    renderId: utms.renderId,
  }
  const urlParams = omitUtmParams ? {} : params
  const ctaUrl = `${config.credibleRoot}/private-student-loans/prequal/role?${querystring.encode({
    ...urlParams,
    role,
  })}${metaQuery}`

  return ctaUrl
}

export { getCtaUrl }
